import { Component, EventEmitter, Input, OnDestroy, Output, TemplateRef } from '@angular/core';
import { ReplaySubject } from 'rxjs';

@Component({
  selector: 'pagination-scrolling',
  templateUrl: './pagination-scrolling.component.html',
  styleUrls: ['./pagination-scrolling.component.scss'],
})
export class PaginationScrollingComponent<T> implements OnDestroy {
  @Input() public list: T[] = [];
  @Input() public itemTemplate: TemplateRef<any>;
  @Input() public scrollContentClass: string;
  @Output() public loadNew: EventEmitter<any> = new EventEmitter<any>();

  private destroy$: ReplaySubject<boolean> = new ReplaySubject<boolean>();

  constructor() {}

  public ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }
}
